import { useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import { AdvisorThemeProvider, advisor } from "Components/AdvisorTheme";
import { useBriefFeedback, useLatestBrief } from "Components/TodaysBrief";
import PulseBanner from "./PulseBanner";
import RevenueSnapshot from "./RevenueSnapshot";
import TopPriorities from "./TopPriorities";
import FullBriefPanel from "./FullBriefPanel";
import RevenueCohort from "./RevenueCohort";
import { usePipelineSelection } from "./usePipelineSelection";

export default function ExecutiveBriefing() {
 const { companyId, profile, ready, brief, profileError, retryProfile, isLoading, isFetching, isError, refetch } = useLatestBrief();
 const fb = useBriefFeedback(companyId, brief);
 const selection = usePipelineSelection();
 const [briefOpen, setBriefOpen] = useState(false);
 const briefLoading = !profileError && (!ready || isLoading || isFetching);
 const now = new Date();
 const greeting = now.getHours() < 12 ? "Good morning" : now.getHours() < 18 ? "Good afternoon" : "Good evening";
 const openBrief = () => setBriefOpen(true);

 return <AdvisorThemeProvider>
  <Box component="main" data-advisor-page sx={{ bgcolor: advisor.page, minHeight: "100%", minWidth: 0 }}>
   <Box sx={{ maxWidth: 1200, mx: "auto", px: { xs: 2, sm: 3, md: 4 }, pt: { xs: 2.5, md: 3.5 }, pb: 3, display: "grid", gap: { xs: 2.5, md: 3 } }}>
    <Box component="header" sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2, flexWrap: "wrap" }}>
     <Box sx={{ minWidth: 0 }}>
      <Typography sx={{ fontSize: 14, color: advisor.subtle, fontWeight: 600 }}>
       {now.toLocaleDateString(undefined, { weekday: "long", month: "long", day: "numeric", year: "numeric" })}
      </Typography>
      <Typography component="h1" sx={{ fontSize: { xs: 28, md: 34 }, fontWeight: 700, color: advisor.text, lineHeight: 1.2, mt: 0.25 }}>
       {greeting}{profile?.firstName ? `, ${profile.firstName}` : ""}!
      </Typography>
      <Typography sx={{ fontSize: { xs: 15, md: 17 }, color: advisor.muted, mt: 0.5 }}>
       Here’s what you need to know about your revenue today.
      </Typography>
     </Box>
     <Button variant="outlined" onClick={openBrief} disabled={!brief} endIcon={<ArrowForwardRoundedIcon />} sx={{ bgcolor: "#FFFFFF", borderColor: advisor.lavenderBorder, whiteSpace: "nowrap" }}>
      View full brief
     </Button>
    </Box>

    <PulseBanner brief={brief} loading={briefLoading} error={isError} profileError={profileError} onRetry={() => refetch()} onRetryProfile={() => retryProfile()} />

    <RevenueSnapshot brief={brief} ready={ready} loading={isLoading || isFetching} error={isError} profileError={profileError} onRetry={() => refetch()} onRetryProfile={() => retryProfile()} onOpenBrief={openBrief} selection={selection} />

    <TopPriorities brief={isError ? undefined : brief} loading={briefLoading} fb={fb} onOpenBrief={openBrief} />

    <RevenueCohort selection={selection} />
   </Box>
   <FullBriefPanel open={briefOpen && !!brief} onClose={() => setBriefOpen(false)} brief={brief} fb={fb} />
  </Box>
 </AdvisorThemeProvider>;
}
